import { useRef } from 'react';

function useLocalRef(ref) {
  const localRef = useRef(null);
  const localRefFunction = element => {
    localRef.current = element;
    if (!ref) {
      return;
    }
    if (typeof ref === 'function') {
      ref(element);
      return;
    }
    ref.current = element;
  };
  return {
    localRef,
    localRefFunction
  };
}

export { useLocalRef };
